import { useState, useEffect } from 'react';
import useDebounce from '@/hooks/useDebounce';
import Input from '@/components/Input';
import axios from 'axios';
import { toast } from 'react-toastify';

const CityAutocomplete = ({
  onCitySelect = () => {},
  labelText = "Ville",
  labelFor = "city",
  id = "city",
  name = "city",
  placeholder = "Entrez votre ville",
  isRequired = true,
  customClass = '',
  divClass = '',
}) => {
  const [input, setInput] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const debouncedInput = useDebounce(input, 500); // 500 ms delay
  const [isSuggestionClicked, setIsSuggestionClicked] = useState(false);

  useEffect(() => {
    if (debouncedInput?.length > 2 && !isSuggestionClicked) {
      const fetchCities = async (inputValue) => {
        try {
          const response = await axios.get(`${import.meta.env.VITE_API_URL}/api/autocomplete-city`, {
            params: {
              input: inputValue,
            },
          });

          if (response.data.cities && Array.isArray(response.data.cities)) {
            setSuggestions(response.data.cities);
          } else {
            setSuggestions([]);
            console.error("Format de réponse inattendu", response.data);
          }
        } catch (error) {
          console.error("Erreur lors de la récupération des suggestions de villes:", error);
          toast.error(error.message, {
            position: 'top-center',
            autoClose: 3500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            theme: 'colored',
          });
        }
      };

      fetchCities(debouncedInput);
    } else {
      setSuggestions([]);
    }
  }, [debouncedInput, isSuggestionClicked]);

  const handleChange = (event) => {
    setInput(event.target.value);
    setIsSuggestionClicked(false);
  };

  const handleSuggestionClick = (city) => {
    setInput(`${city.city} (${city.postal_code})`);
    setSuggestions([]);
    setIsSuggestionClicked(true);

    // Passer les infos de la ville au composant parent
    onCitySelect({
      city: city.city,
      postal_code: city.postal_code,
      region: city.region,
      country: city.country,
    });
  };

  return (
    <>
      <Input
        handleChange={handleChange}
        value={input}
        labelText={labelText}
        labelFor={labelFor}
        id={id}
        name={name}
        type="text"
        isRequired={isRequired}
        placeholder={placeholder}
        customClass={customClass}
        divClass={divClass}
      />
      {suggestions?.length > 0 && (
        <div className="relative w-full">
          <div className="suggestions-container w-full absolute z-10 bg-white border border-gray-300 rounded-md mt-1 max-h-60 overflow-y-auto">
            {suggestions.map((city, index) => (
              <div 
                key={index} 
                className="suggestion p-2 cursor-pointer hover:bg-gray-100"
                onClick={() => handleSuggestionClick(city)}
              >
                {city.city} ({city.postal_code}) - {city.region}
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default CityAutocomplete; 